import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface AnonSessionState {
  sessionId: string | null;
  setSessionId: (id: string | null) => void;
}

export const useAnonSessionStore = create<AnonSessionState>()(
  persist(
    (set) => ({
      sessionId: null,
      setSessionId: (id) => set({ sessionId: id }),
    }),
    {
      name: 'anon-session',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
